<template>
	<div v-if="!isSubscribe">
		<router-link
			:to="{ path: '/settings', query: { tab: 'billing' } }"
		>
			<div
				class="flex cursor-pointer items-center gap-1 rounded-[6px] px-2.5 py-1.5 hover:bg-won-bg-blue"
				:class="collapsed && 'justify-center'"
			>
				<svg
					width="16"
					height="17"
					viewBox="0 0 16 17"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>            <g clip-path="url(#clip0_3798_34975)">            <path
					d="M10.6663 12.5V13.8333H5.33301V12.5H10.6663ZM7.33301 5.82663V11.1666H8.66634V5.82663H10.6663L7.99967 3.16663L5.33301 5.82663H7.33301Z"
					fill="#8897AA"
				/>            </g>            <defs>            <clipPath id="clip0_3798_34975">            <rect
					width="16"
					height="16"
					fill="white"
					transform="translate(0 0.5)"
				/>            </clipPath>            </defs>        </svg>
        
				<div
					v-if="!props.collapsed"
					class="ml-1 font-[Inter] text-sm font-medium text-won-gray-blue"
				>
					Upgrade Plan
				</div>
			</div>
		</router-link>
	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useSubscriptionPlanStore } from '../../store/subscription.store';

const props = defineProps({
	collapsed: {
		type: Boolean,
		default: false,
	},
});

const { isSubscribe } = storeToRefs(useSubscriptionPlanStore());
</script>
